import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonMain, CancelBtn } from "components";
import { httpRequestsOnLoadActions, httpRequestsOnSuccessActions, organizationActions } from 'store';
import { Svg } from "assets";
import { authService } from '../../../store/organizations/organizations.service';

const ACTION_TYPE = 'EDIT_ORG_SOCIALS';

export const OrgReviews = () => {
    const { orgSocials, org } = useSelector((state) => ({
        orgSocials: state.orgs.orgSocials,
        org: state.orgs.organizationsById
    }));

    const dispatch = useDispatch();
    const [inputs, setInputs] = useState([ {
        icon: Svg.OrgGoogle,
        name: "googlePlaceId",
        placeholder: "Add Google Place ID",
        value: orgSocials?.googleReviews?.entityId
    },
        {
            icon: Svg.OrgYelp,
            name: "yelpBusinessId",
            placeholder: "Add Yelp Place ID",
            value: orgSocials?.yelpReviews?.entityId
        }]);



    // useEffect(() => {
    //     if (orgSocials) {
    //         const socialInfo = {...orgSocials};
    //         orgSocials?.googleReviews ? (socialInfo.googlePlaceId = orgSocials?.googleReviews?.entityId) : delete socialInfo.googlePlaceId;
    //         orgSocials?.yelpReviews ? (socialInfo.yelpBusinessId = orgSocials?.yelpReviews?.entityId) : delete socialInfo.yelpBusinessId;
    //         setInputs(socialInfo);
    //     }
    // }, [orgSocials]);

    const handleChange = (e) => {
            const { name, value } = e.target;
            setInputs((prevState) =>
                prevState.map((item) =>
                    item.name === name ? { ...item, value } : item
                )
            );
    };

    const handleDelete = (name) => {
        setInputs((prevState) =>
            prevState.map((item) =>
                item.name === name ? { ...item, value: '' } : item
            )
        );
    };

    const handleSave = () => {
        const params = {
            ...orgSocials
        };

        inputs?.forEach((i => {
            if (i?.value) {
                params[i?.name] = i?.value;
            } else {
                params[i?.name] = null;
            }
        }));
        delete params?.googleReviews;
        delete params?.yelpReviews;
        dispatch(httpRequestsOnLoadActions.appendLoading(ACTION_TYPE))
        authService.editOrgSocialsService(org?.id,params).then((res) => {
            if (res?.data) {
                dispatch(httpRequestsOnSuccessActions.appendSuccess(ACTION_TYPE))
                dispatch(httpRequestsOnLoadActions.removeLoading(ACTION_TYPE))
                dispatch(organizationActions.getOrgSocials(org?.id));
            }
        }).catch(() => {
            dispatch(httpRequestsOnLoadActions.removeLoading(ACTION_TYPE))
        });
        // dispatch(organizationActions.editOrgSocials(org?.id, params));
    };

    return (
        <>
            <div>
                <div className="subtitle-box">
                    <h3 className="subtitle">Connect Reviews</h3>
                    <p className="paragraph">
                        Add the google place ID or the yelp business ID of the organization to display reviews from these platforms.
                    </p>
                </div>
                <div className="reviews-inputs">
                    {inputs?.map((i, j) => (
                        <div className="connect-box" key={j}>
                            <div
                                className={`connect-box-icon_input ${i?.value?.length > 0 ? "connect-box-icon_input-fill" : ""}`}>
                                <div className="social-icon">
                                    <img src={i?.icon} alt="icon" />
                                </div>
                                <input
                                    type={"text"}
                                    className="social-input"
                                    name={i?.name}
                                    placeholder={i?.placeholder}
                                    value={i?.value}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="social-delete">
                                <button type="button" className="btn-delete" onClick={() => handleDelete(i?.name)}>
                                    <Svg.Close />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="edit-org-btns">
                <CancelBtn />
                <ButtonMain type={'button'} onClick={handleSave} actionTye={ACTION_TYPE} text="Save" />
            </div>
        </>
    );
};
